<span *ngIf="translateString">
  {{ translateString }}
</span>
